var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import { DISTRIBUTION_TYPE } from "~/config/enum.config";
var AllotModule = namespace("case-allot");
var DistributionPattern = /** @class */ (function (_super) {
    __extends(DistributionPattern, _super);
    function DistributionPattern() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.patternCollection = DISTRIBUTION_TYPE;
        return _this;
    }
    DistributionPattern.prototype.emitModeChange = function () { };
    DistributionPattern.prototype.emitDebtChange = function () { };
    Object.defineProperty(DistributionPattern.prototype, "distributionMode", {
        get: function () {
            return this.mode;
        },
        set: function (val) {
            this.updateMode(val);
            this.emitModeChange();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DistributionPattern.prototype, "debtCase", {
        get: function () {
            return this.debt === "YES";
        },
        set: function (val) {
            this.updateDebtState(val);
            this.emitDebtChange();
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        AllotModule.State
    ], DistributionPattern.prototype, "caseIds", void 0);
    __decorate([
        AllotModule.State
    ], DistributionPattern.prototype, "mode", void 0);
    __decorate([
        AllotModule.State
    ], DistributionPattern.prototype, "debt", void 0);
    __decorate([
        AllotModule.Mutation
    ], DistributionPattern.prototype, "updateMode", void 0);
    __decorate([
        AllotModule.Mutation
    ], DistributionPattern.prototype, "updateDebtState", void 0);
    __decorate([
        Emit('modeChange')
    ], DistributionPattern.prototype, "emitModeChange", null);
    __decorate([
        Emit('debtChange')
    ], DistributionPattern.prototype, "emitDebtChange", null);
    DistributionPattern = __decorate([
        Component({
            components: {},
        })
    ], DistributionPattern);
    return DistributionPattern;
}(Vue));
export default DistributionPattern;
